module.exports = __webpack_public_path__ + "933dedef5cfbd3f083624a88a5266719.png";